// Does the supplier's latest כרטסת cover a date window? The server computes
// covered_through ('YYYY-MM', see server/lib/latestLedger.js); coverage is
// cumulative, so a window is covered when its END month is ≤ covered_through.
// A multi-month range therefore shows the mark only when all of it is covered.
// No window (all dates) → no mark: there is no month to vouch for.
export function ledgerCoversWindow(latestLedger, dateTo) {
  const through = latestLedger?.covered_through;
  if (!through || !dateTo) return false;
  const m = /^(\d{4})-(\d{2})/.exec(String(dateTo));
  if (!m) return false;
  return `${m[1]}-${m[2]}` <= through;
}
